module.exports = __webpack_public_path__ + "static/media/sportconnect_mono.7c7ea71c.svg";